import type { FAQPage, Question, WithContext } from 'schema-dts';
import { JsonLd } from '../../JsonLd/JsonLd';
import type { FaqItem } from '../components';

type FaqPageJsonLdProps = {
  items: FaqItem[];
};

function toQuestion(item: FaqItem): Question | undefined {
  const name = item.question?.trim();
  const text = item.answer?.trim();

  if (!name || !text) {
    return undefined;
  }

  return {
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  };
}

function FaqPageJsonLd({ items }: FaqPageJsonLdProps) {
  const mainEntity = items.flatMap(item => {
    const question = toQuestion(item);
    return question ? [question] : [];
  });

  if (mainEntity.length === 0) {
    return null;
  }

  const faqPage: WithContext<FAQPage> = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  };

  return <JsonLd json={faqPage} data-testid="faq-page-json-ld" />;
}

export { FaqPageJsonLd, type FaqPageJsonLdProps };
